// 2.5 获取设备地图信息
import request from '@/router/axios';
export function deviceListMapInfo() {
  return request({
    url: "/api/statis/device/list",
    method: 'get',
    data: {}
  });
}
export function statisState() {
  return request({
    url: "/api/statis/state",
    method: 'get',
    data: {}
  });
}
export function statisWork() {
  return request({
    url: "/api/statis/work",
    method: 'get',
    data: {}
  });
}
export function distributionData() {
  return request({
    url: "/api/statis/distribution",
    method: 'get',
    data: {}
  });
}
export function statisSales() {
  return request({
    url: "/api/statis/sales",
    method: 'get',
    data: {}
  });
}